

const template = document.createElement('template');
template.innerHTML = `
<style>

  :host {
    display: block;
    width: 100%;
  }
  
  * { 
    box-sizing: border-box; 
  }

  .personalisation-textarea {
    position: relative;
    width: 100%;
  }

  .textarea {
    background-color: var(--transparent-navy-navy-4);
    border: none;
    border-radius: 1rem;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    letter-spacing: 0.135rem;
    height: 7.1875rem;
    margin-bottom: 1.25rem;
    max-width: 100%;
    width: 100%;
    padding: 1.25rem 4.5rem 0.5rem 1.25rem;
    text-transform: capitalize;
    resize: none;
    font-family: 'Sohne', sans-serif
  }

  .textarea::placeholder {
    color: rgba(18, 50, 71, 0.40);
  }

  .textarea.is-uppercase {
    text-transform: uppercase;
  }

  .text-count {
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    letter-spacing: 0.135rem;
    text-transform: uppercase;
    color: rgba(18, 50, 71, 0.40);
  }
  .personalisation-textarea {
    position: relative;
    width: 100%;
  }
</style>

<div class="personalisation-textarea" part="navigation">
  <textarea class="input textarea"></textarea>
  <div class="text-count"></div>
</div>
`;
export class PersonalisationTextarea extends HTMLElement {

  private readonly root: HTMLDivElement | null;
  private readonly textarea: HTMLTextAreaElement;
  private readonly textCount: HTMLDivElement;
  private componentPlaceholder: string = this.getAttribute('placeholder') || "";
  private componentValue: any = this.getAttribute('value') || "";
  private uppercase: boolean = this.hasAttribute('is-uppercase');
  private key: string | null = null;
  private maxCharacters: number = 0;

  constructor() {
    super();

    this.key = this.getAttribute('key');
    if (!this.key) console.error('Need to provide a key which matches one in the personalisationData object', this);

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.root = shadowRoot.querySelector('.personalisation-textarea')!;
    this.textarea = shadowRoot.querySelector('.textarea')!;
    this.textCount = shadowRoot.querySelector('.text-count')!;

    this.textarea.addEventListener('input', this.handleInput.bind(this));
  }

  connectedCallback() {
    this.textarea.placeholder = this.componentPlaceholder;
    if(this.componentValue) this.textarea.value = this.componentValue;
    if (this.uppercase) this.textarea.classList.add('is-uppercase');
    let currentLength = this.componentValue ? parseInt(this.componentValue.length) : 0;

    this.maxCharacters = parseInt(this.getAttribute('max-characters') || '0');
    this.textCount.textContent = `${currentLength}/${this.maxCharacters}`;
    this.textarea.setAttribute('maxlength', `${this.maxCharacters}`);
  }

  clearInput() {
    this.textarea.value = '';
    this.textCount.textContent = `0/${this.maxCharacters}`;
  }
  
  private handleInput(e) {
    const currentLength = (e.target as HTMLTextAreaElement).value.length;
    this.textCount.textContent = `${currentLength}/${this.maxCharacters}`;

    const event = new CustomEvent('data_update', { 
      detail: { 
        data: {
          [this.key as string]: this.textarea.value, // Spread multiple key-value pairs dynamically
        }
      },
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

}

if(!customElements.get('personalisation-textarea')) {
  customElements.define('personalisation-textarea', PersonalisationTextarea);
}